import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const ProcessFilesRequest = (fileLocation) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportKpis/ProcessFiles`,
	params: { fileLocation }
});

export const GetSiteStringRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ReportKpis/GetSiteString`,
	params: { }
});
